import { Stack } from '@optimus-web/core';
import { SmsUsaRegistration, TextMessagingConfiguration } from '@mews-commander/data-access';
import { useFeatureFlag } from '@mews/framework';
import { FeatureFlag } from '@mews-commander/enums';
import { Tabs } from '../Tabs/Tabs';
import { TabItem } from '../Tabs/tabItem';
import { GeneralTab } from '../GeneralTab/GeneralTab';
import { ConfigurationNotFound } from '../ConfigurationNotFound';
import { OnlineCheckInTab } from '../Tabs/OnlineCheckInTab';
import { AfterStartTab } from '../AfterStartTab/AfterStartTab';

interface TextMessagingContentProps {
    configuration: TextMessagingConfiguration | null | undefined;
    enterpriseId: string;
    smsUsaRegistration: SmsUsaRegistration | null | undefined;
}

export const TextMessagingContent = ({
    configuration,
    enterpriseId,
    smsUsaRegistration,
}: TextMessagingContentProps) => {
    const isAfterStartSMSEnabled = useFeatureFlag(FeatureFlag.afterStartSMSEnabled);
    const areSeparateSMSTypesEnabled = useFeatureFlag(FeatureFlag.separateSMSTypesEnabled);

    if (configuration == null) {
        return <ConfigurationNotFound enterpriseId={enterpriseId} />;
    }

    return (
        <Stack vertical spacing="300">
            <Tabs isAfterStartTabVisible={isAfterStartSMSEnabled && areSeparateSMSTypesEnabled}>
                {({ activeTabValue }) => {
                    switch (activeTabValue) {
                        case TabItem.General: {
                            return (
                                <GeneralTab
                                    configuration={configuration}
                                    enterpriseId={enterpriseId}
                                    smsUsaRegistration={smsUsaRegistration}
                                />
                            );
                        }
                        case TabItem.OnlineCheckIn: {
                            return <OnlineCheckInTab enterpriseId={enterpriseId} configuration={configuration} />;
                        }
                        case TabItem.AfterStart: {
                            if (!isAfterStartSMSEnabled || !areSeparateSMSTypesEnabled) {
                                return null;
                            }
                            return <AfterStartTab enterpriseId={enterpriseId} configuration={configuration} />;
                        }
                    }
                }}
            </Tabs>
        </Stack>
    );
};
